/**
 * web/src/shell/tabs.tsx — the bottom-rail tab definitions and their inline
 * 20×20 SVG icons, moved verbatim out of App.tsx (card WUHnArc6lNID).
 */
import type { TabDef } from '../components/TabBar';
import type { Tab } from './dest';

/** Inline SVG icons for the four intent tabs. 20×20, currentColor stroke. */
const Icons = {
  thread: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 3h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M7 8h6M7 12h4" />
    </svg>
  ),
  us: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6.5" cy="6.5" r="2.5" />
      <circle cx="13.5" cy="6.5" r="2.5" />
      <path d="M3 16c0-2.5 2.5-4.5 5-4.5h4c2.5 0 5 2 5 4.5" />
    </svg>
  ),
  life: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="2" width="14" height="16" rx="2" />
      <path d="M7 6h6M7 10h6M7 14h4" />
    </svg>
  ),
  notebook: (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 3h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M7 3v14" />
    </svg>
  ),
};

export const TABS: TabDef[] = [
  { key: 'thread', label: 'Thread', icon: Icons.thread },
  { key: 'us', label: 'Us', icon: Icons.us },
  { key: 'life', label: 'Life', icon: Icons.life },
  /* Card anKalYfYvokw (IA phase 2), corrected by Jonathan 2026-10-28: the
     SURFACE is still Notebook — only the link collection took the name
     Collection. The tab id stays `notebook` so every walk selector, panel id
     and deep link is unaffected by either rename. */
  { key: 'notebook', label: 'Notebook', icon: Icons.notebook },
  /* Card HXzRl6doT9DQ (Jonathan email 2026-11-04 17:37: "search still in
     bottom nav should only be in explore") — the fifth rail destination is
     gone. Card 2Cium84y07TE had promoted Search onto the rail; that decision
     is reversed, so the bar is four destinations plus the Explore slot again.
     Search is NOT deleted: `#search` still resolves (dest.ts, panels.tsx) and
     the Explore drawer carries the `#btn-search` row (MoreMenu.tsx). */
];
